// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';

import { useTranslation } from 'react-i18next';
import LoginLayout from '../../../flows/login/components/LoginLayout';
import LoginCard from '../../../flows/login/components/LoginCard';
import Heading from '../../Heading';
import Button from '../../Button';
import { LOGIN_NAVIGATION_MAP } from '../../../flows/login/components/LoginNavigation/constants';
import { useStore } from '../../../store';
import { TAKE_A_BREAK_SCREEN } from '../../../flows/login/constants';

const TookABreak = () => {
  const setCurrentPage = useStore((state) => state.setCurrentPage);
  const { HEADER, TEXT, BUTTON } = TAKE_A_BREAK_SCREEN;

  const { t } = useTranslation();

  return (
    <LoginLayout backButton backDestination={LOGIN_NAVIGATION_MAP.VERIFICATION_CODE}>
      <LoginCard className='w-[50%] min-w-[24rem] left-[20%] top-[20%]' backgroundColor='bg-transparent'>
        <Heading title={t(HEADER)} className='w-[30rem] heading text-bw08 font-metricSemibold' />
        <Heading title={t(TEXT)} className='w-[30rem] text-base mt-2 mb-6 text-bw07 font-metric' />
        <Button
          id='TookABreak'
          onClick={() => setCurrentPage(LOGIN_NAVIGATION_MAP.WELCOME)}
          title={t(BUTTON)}
          className='font-metricBold leading-4 tracking-wide text-sm text-bw00 w-full h-12 rounded bg-action03 '
        />
      </LoginCard>
    </LoginLayout>
  );
};

export default TookABreak;
